import { ENV } from '../env';

export type LogFn = (message?: unknown, ...optionalParams: unknown[]) => void;

export type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error';

export interface Logger {
  trace: LogFn;
  debug: LogFn;
  info: LogFn;
  warn: LogFn;
  error: LogFn;
}

/* eslint-disable @typescript-eslint/no-unused-vars */
const DO_NOTHING: LogFn = (_message?: unknown, ..._optionalParams: unknown[]) => {
  // do nothing.
};

/** Logger which outputs to the browser console */
export class ConsoleLogger implements Logger {
  readonly trace!: LogFn;
  readonly debug!: LogFn;
  readonly info!: LogFn;
  readonly warn!: LogFn;
  readonly error!: LogFn;

  constructor(options?: { level?: LogLevel }) {
    const { level } = options || {};

    switch (level) {
      case 'trace':
        this.trace = console.trace.bind(console);
        this.debug = console.debug.bind(console);
        this.info = console.info.bind(console);
        this.warn = console.warn.bind(console);
        this.error = console.error.bind(console);
        break;
      case 'debug':
        this.trace = DO_NOTHING;
        this.debug = console.debug.bind(console);
        this.info = console.info.bind(console);
        this.warn = console.warn.bind(console);
        this.error = console.error.bind(console);
        break;
      case 'info':
        this.trace = DO_NOTHING;
        this.debug = DO_NOTHING;
        this.info = console.info.bind(console);
        this.warn = console.warn.bind(console);
        this.error = console.error.bind(console);
        break;
      case 'warn':
        this.trace = DO_NOTHING;
        this.debug = DO_NOTHING;
        this.info = DO_NOTHING;
        this.warn = console.warn.bind(console);
        this.error = console.error.bind(console);
        break;
      case 'error':
        this.trace = DO_NOTHING;
        this.debug = DO_NOTHING;
        this.info = DO_NOTHING;
        this.warn = DO_NOTHING;
        this.error = console.error.bind(console);
        break;
      default:
    }
  }
}

export const logger = new ConsoleLogger({ level: ENV.LOG_LEVEL });
